import axios from 'axios';
// import QS from 'qs';
import { iscode } from './app';
import config from '@/config'
import { setToken, getToken } from '@/libs/util'
import router from '@/routers'
import { Modal } from 'ant-design-vue';
// export const baseUrl = (process.env.NODE_ENV === '' ? config.baseUrl.dev : config.baseUrl.pro) 
class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }
  interceptors (instance) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      const { data, status } = res
        if (data.code == 10011) {
          setToken('')
          if(router.currentRoute._value.href!='/login'){
            router.push({ name: 'Login' })
          }
        } else if(data.code === 48001){
          Modal.confirm({
            centered: true,
            content: "当前账号未绑定微信,是否跳转绑定",
            onOk: async () => {
              window.location.href = data.data.authorizationUrl
            },
          });
        }else {
          iscode(data)
        }
        // throw new Error(data.msg)
        return { data, status }
      // } else {
      //   return { data, status }
      // }
    }, error => {
      if(error.response.data){
        iscode({
          code:0,
          msg:error.response.data.msg || ''
        },true)
      }
      console.log(error)
      return Promise.reject(error)
    })
  }
  request (options,headers={}) {
    const instance = axios.create()
    let Authorization = getToken()
    var config={}
    if(Authorization){
       config={
        baseURL: this.baseUrl,
        headers: {
          Authorization: getToken(),
          ...headers
        }
      }
    }else{
       config={
        baseURL: this.baseUrl,
        headers:{},
      }
    }
    options = Object.assign(config, options)
    this.interceptors(instance)
    return instance(options)
  }
}
// 品牌商
export const baseUrl =config.baseUrl[process.env.VUE_APP_type]
const api_axios = new HttpRequest(baseUrl)
export default api_axios

// 一物一码
export const smartUrl =config.smartUrl[process.env.VUE_APP_type]
export  const api_smart= new HttpRequest(smartUrl)

// 在线订货
export const onlineOrderUrl =config.onlineOrderUrl[process.env.VUE_APP_type]
export  const api_onlineOrder= new HttpRequest(onlineOrderUrl)


